.controlsContainer {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.unsavedChangesNavigateChoiceButtons {
    display: flex;
    gap: 12px;
    justify-content: space-between;
    margin-top: 24px;
}

.unsavedChangesNavigateChoiceButtonsRight {
    display: flex;
    gap: 12px;
}
